import { Component, input } from '@angular/core';
import { CropSoilAnalysis } from 'src/app/bem/shared/models/models';
import { ValuationStatusBarComponent } from '../valuation-status-bar/valuation-status-bar.component';

type ValuationKey = Extract<keyof CropSoilAnalysis, `${string}Valuation`>;

interface ValuationItem {
  key?: ValuationKey;
  show: boolean;
}

@Component({
    selector: 'app-valuation-bar-column',
    styleUrl: '../../crop-soil-analysis-block.component.scss',
    template: `
    <div class="column-container">
      <div [class]="isPlant() ? 'plant-values' : 'soil-values'">
        @for (item of getValuationItems(); track item.key ?? item) {
          <div class="value-item-valuation-bar">
            @if (item.show) {
              <app-valuation-status-bar [value]="getValuationValue(item.key) ?? 0"/>
            }
          </div>
        }
      </div>
    </div>
  `,
    imports: [ValuationStatusBarComponent],
})
export class ValuationBarColumnComponent {
  hasSoilNitrate = input<boolean>();
  isPlant = input<boolean>();
  data = input<CropSoilAnalysis>();
  private readonly soilNitrateValuationItem: ValuationItem = { show: false };

  private readonly plantValuationItems: ValuationItem[] = [
    { key: 'nPlantValuation', show: true },
    { key: 'kPlantValuation', show: true },
    { key: 'mnPlantValuation', show: true },
    { show: false },
    { show: false },
  ];

  private readonly soilValuationItems: ValuationItem[] = [
    { key: 'kSoilValuation', show: true },
    { key: 'mgSoilValuation', show: true },
    { key: 'mnSoilValuation', show: true },
    { key: 'bSoilValuation', show: true },
    { key: 'sSoilValuation', show: true },
  ];

  protected getValuationItems(): ValuationItem[] {
    if (this.isPlant()) {
      return this.plantValuationItems;
    }

    if (this.hasSoilNitrate()) {
      return [this.soilNitrateValuationItem, ...this.soilValuationItems];
    }

    return this.soilValuationItems;
  }

  protected getValuationValue(key?: ValuationKey): number | undefined {
    return key ? this.data()?.[key] : undefined;
  }
}
